module.exports = __webpack_public_path__ + "static/img/img_logo.195cf723.png";